import { DefaultMeetingSession, VideoTileState } from 'amazon-chime-sdk-js';
import { ProviderConfig } from '../../lib/core/types';
import { UserType } from '../../lib/video/types';

export type VideoConfiguration = {
  meeting: any;
  attendee?: any;
};

type MeetingAppointment = {
  id: number;
  type: string;
};

type MeetingAttendeeBasicInfo = {
  id: number;
  name: string;
};

type MeetingMemberAttendee = MeetingAttendeeBasicInfo & {
  authToken: string;
  clinicId: number;
  id: number;
};

export type MeetingInformation = {
  videoConfig: VideoConfiguration | null;
} & (
  | {
      userType: UserType.Provider;
      appointment?: MeetingAppointment;
      meetingAttendees: {
        provider: MeetingAttendeeBasicInfo & {
          authToken: string;
          id: number;
        };
        member: MeetingMemberAttendee;
      };
      providerConfig?: ProviderConfig;
      ongoingRecordingPipelineId?: string;
      isAutomaticRecordingAllowed?: boolean;
    }
  | {
      userType: UserType.Member;
      appointment?: MeetingAppointment;
      meetingAttendees: {
        provider: MeetingAttendeeBasicInfo;
        member: MeetingMemberAttendee;
      };
    }
  | {
      userType: UserType.Guest;
      meetingAttendees: {
        provider: MeetingAttendeeBasicInfo;
        member: MeetingAttendeeBasicInfo & { clinicId: number };
      };
    }
);

export type Participant = {
  isCameraEnabled: boolean;
  isRemote: boolean;
  tileState: VideoTileState;
  boundElement?: React.RefObject<HTMLVideoElement>;
  isSharing?: boolean;
  name?: string;
};

export type IOVideoSetupResult = {
  success: boolean;
  session?: DefaultMeetingSession | null;
  message?: string;
};

export enum MeetingPusherEventName {
  HostHasAskedToJoinTheCall = 'host-has-asked-to-join-the-call',
  AttendantHasAskedToJoinTheCall = 'attendant-has-asked-to-join-the-call',
  HostHasJoinedTheCall = 'host-has-joined-the-call',
  AttendantHasJoinedTheCall = 'attendant-has-joined-the-call',
}

export type PusherPresenceMembers = {
  members: Record<string, any | null>;
  count: number;
  myID: string;
  me: {
    id: string;
    info: any | null;
  };
};

export type PusherMember = {
  id: string;
  participantUuid: string;
  name: string;
  info: unknown | null;
  ts: number;
};

// Pusher events presence/private

export enum PusherSystemEvent {
  SubscriptionSucceeded = 'pusher:subscription_succeeded',
  SubscriptionError = 'pusher:subscription_error',
  MemberAdded = 'pusher:member_added',
  MemberRemoved = 'pusher:member_removed',
  Error = 'pusher:error',
}

export enum PusherClientEvent {
  ClientJoined = 'client-joined',
}
